<template>
  <div class="orderInfo">
    <text-title :title="title"/>
    <div class="item">
      <LjbItem
        v-for="(item,key) in orderInfo"
        :key="key"
        :item="item"/>
    </div>
  </div>
</template>

<script>
import TextTitle from '@/components/title/TextTitle'
import LjbItem from '@/components/LjbLeftItem'
export default {
  name: 'ListOrderInfo',
  components: {LjbItem, TextTitle},
  props: {
    orderInfo: {
      type: Array,
      default: function () {
        return ''
      }
    }
  },
  data () {
    return {
      title: '订单信息'
    }
  }
}
</script>

<style lang="scss" scoped>
.item{
  padding: 13.5px 0;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/list/listOrderInfo.vue